import React from 'react';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const CommerceCheckoutOrderItemOptionListItem = Atom.createRender((props) => {
  const {attributes, classes, context, data, generateAttributes, renderChild} =
    props;
  return (
    <li {...generateAttributes(attributes, classes)}>
      {getChildren(data).map((child: EvaluatedNodeData) =>
        renderChild(child, context)
      )}
    </li>
  );
});

const config = createIntegratedAtom({
  showEmpty: false,
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Dynamo'), iconName('CollectionItem')),
  },
  displayName: 'Option',
  constraints: {
    pinToParent: true,
    ancestors: [
      {
        is: 'CommerceCheckoutOrderItemOptionList',
        rule: 'AtLeastOne',
      },
    ],
  },
  render: CommerceCheckoutOrderItemOptionListItem,
  fields: {children: TListOfElement},
});

export default config;
